import $ from './gs-zepto';

init();

function init() {

	let thisLoc = location.pathname;
	let thatLoc = sessionStorage.getItem('scrollPath');
	if (!/^\/content\-preview\//.test(thisLoc)) return;
	if (thisLoc != thatLoc) resetPosition();

	$(document)
		.on('scroll', savePosition)
		.on('ready', restorePosition);

}



function resetPosition() {

	let loc = location.pathname;
	sessionStorage.setItem('scrollPath', loc);
	sessionStorage.removeItem('scrollPosition');

}



function savePosition() {

	let pos = $(window).scrollTop();
	sessionStorage.setItem('scrollPosition', pos);

}



function restorePosition() {

	let pos = sessionStorage.getItem('scrollPosition');
	$(window).scrollTop(pos);

}
